import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { ReferenceState, RetailRocketState, StateWithReference } from '../reference-state';
import { getReferenceFeatureState } from './feature.selector';

export const getRetailRocketState: MemoizedSelector<StateWithReference, RetailRocketState> = createSelector(
  getReferenceFeatureState,
  (state: ReferenceState) => state.RR,
);
// Recomendation
export const productRecomendationListState = (
  id: string,
): MemoizedSelector<StateWithReference, StateUtils.LoaderState<number[]>> =>
  createSelector(getRetailRocketState, (state: RetailRocketState) => {
    return StateUtils.entityLoaderStateSelector<number[]>(state.recomendationList, id);
  });

export const productRecomendationListValue = (id: string): MemoizedSelector<StateWithReference, number[]> =>
  createSelector(getRetailRocketState, (state: RetailRocketState) => {
    return StateUtils.entityValueSelector<number[]>(state.recomendationList, id);
  });

export const productRecomendationListLoading = (id: string): MemoizedSelector<StateWithReference, boolean> =>
  createSelector(getRetailRocketState, (state: RetailRocketState) => {
    return StateUtils.entityLoadingSelector<number[]>(state.recomendationList, id);
  });

export const productRecomendationListsError = (id: string): MemoizedSelector<StateWithReference, boolean> =>
  createSelector(getRetailRocketState, (state: RetailRocketState) => {
    return StateUtils.entityErrorSelector<number[]>(state.recomendationList, id);
  });

export const productRecomendationListSuccess = (id: string): MemoizedSelector<StateWithReference, boolean> =>
  createSelector(getRetailRocketState, (state: RetailRocketState) => {
    return StateUtils.entitySuccessSelector<number[]>(state.recomendationList, id);
  });
